import React from 'react'
import CPartnerSlider from '@dfb/gatsby-dfb-theme/src/components/elements/c_partner_slider'
import DfbHeadline from '@dfb/gatsby-dfb-theme/src/components/ui-kit/dfb_headline'
import Section from '@dfb/gatsby-dfb-theme/src/components/blocks/section'
import CCardAd from '@dfb/gatsby-dfb-theme/src/components/elements/c_card_ad'
import MSuperBanner from '../blocks/m_superbanner'
import { HeadlessSponsorLink, Image, Partners } from '../../types/types'
import CCardInfoTeaser from '../elements/c_card_info_teaser'

type TeaserImage = {
  image_headline: string
  image_overline: string
  image_description: string
  image_alternative: string
  image_link: string
  image_link_obj: {
    url: string
    type: string
    title: string
    target: string
  }
  image: Array<Image>
}

function partnerExists(partner: HeadlessSponsorLink) {
  return partner && ((partner.name && partner.name.length) || partner.logo !== 'none' || partner.url)
}

function partnersExists(partners: Partners) {
  if (partners) {
    for (const partner of partners.partners) {
      if (partnerExists(partner)) return true
    }

    for (const partner of partners.premiumPartners) {
      if (partnerExists(partner)) return true
    }
  }

  return false
}

function MCardTeasers({ data }) {
  const {
    headline,
    images,
    partners,
  }: {
    headline: string
    images: Array<TeaserImage>
    partners: Partners
  } = data

  const hasPartners = partnersExists(partners)

  return (
    <Section baseClass="m-CardNews" defaultPadding="small" data={data}>
      <div className="m-CardNews-wrapper">
        <div className="m-CardNews-container">
          {headline && <DfbHeadline headline_level="h2" headline={headline} add_class="m-CardNews-headline" />}
          <div className="m-CardNews-grid">
            {images.map((card, i) => (
              <CCardInfoTeaser
                image={card.image[0]}
                link={card.image_link}
                link_obj={card.image_link_obj}
                headline={card.image_headline}
                overline={card.image_overline}
                description={card.image_description}
                link_text={card.image_alternative}
                key={i}
              />
            ))}
            <div className={`m-CardNews-partner-ad${!hasPartners ? ' without-partners' : ''}`}>
              {hasPartners && <CPartnerSlider data={partners} />}
              <CCardAd />
            </div>
          </div>
          <div className="m-CardNews-load-more">
            <div className="m-CardNews-superbanner" data-testid="superbanner">
              <MSuperBanner />
            </div>
          </div>
        </div>
      </div>
    </Section>
  )
}

export default MCardTeasers
